/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=b9129620&scoped=true&"
import script from "./GroupManage.vue?vue&type=script&lang=js&"
export * from "./GroupManage.vue?vue&type=script&lang=js&"
import style0 from "./GroupManage.vue?vue&type=style&index=0&id=b9129620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9129620",
  null
  
)

export default component.exports